export default "__VITE_ASSET__982aa26c__"